// Report filter configurations - defines which filters are used by each report type

export const REPORT_FILTER_CONFIGS = {
	salesAnalysis: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	companyBreakdownSales: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	customerAnalytics: [
		'dateRange',
		'customers',
		'leadOrCustomer',
		'groups',
		'businessTypes',
		'items',
		'productCategories',
		'companies',
	],

	inventoryReports: [
		'dateRange',
		'items',
		'productCategories',
		'warehouses',
		'companies',
	],

	territoryAnalysis: ['dateRange', 'customers', 'salespeople', 'companies'],

	activeOrders: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	clientPaymentStatus: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	kpiOverview: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'teams',
		'companies',
	],

	salesPipeline: [
		'dateRange',
		'opportunityStages',
		'salespeople',
		'businessTypes',
		'companies',
	],

	goalsTable: ['dateRange', 'salespeople', 'teams', 'companies'],

	/**
	 * PD-16801 — the Visit Log. Salespeople and Teams pick whose visits
	 * (the rep who logged them); the rest narrow by what was recorded.
	 */
	visitLog: [
		'dateRange',
		'salespeople',
		'teams',
		'visitStatuses',
		'visitTypes',
		'visitOutcomes',
	],

	accountsReceivableAging: [
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	taxSummary: ['dateRange', 'customers', 'companies'],

	cashReceipts: [
		'dateRange',
		'customers',
		'salespeople',
		'companies',
		'transactionStatus',
		'transactionPaymentMethod',
		'transactionCardType',
	],

	/**
	 * PD-14968 — declared here rather than inline on the page so the sidebar,
	 * the mobile tray and the dashboard widget picker cannot drift apart.
	 * `orderStatus` narrows to the states being chased (open orders that are
	 * already billed, say) instead of reading a whole period.
	 */
	orderReconciliation: [
		'orderKeywords',
		'customers',
		'salespeople',
		'companies',
		'orderStatus',
		// PD-15127 — chase one class of problem at a time; rows leave the view
		// as they are put right, so it reads as a worklist.
		'reconciliationFlags',
	],

	grossProfitDetail: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	creditManagement: [
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	quoteItemDemandSummary: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	quoteDemandByCustomer: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	// No dateRange — saved prices are a current-state concept, not period-based.
	customerSavedPrices: [
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	promoRedemptions: ['dateRange', 'customers', 'companies'],
} as const;
